import { render, staticRenderFns } from "./shopping-list-item.vue?vue&type=template&id=5afd9718&scoped=true&"
import script from "./shopping-list-item.vue?vue&type=script&lang=js&"
export * from "./shopping-list-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afd9718",
  null
  
)

export default component.exports